import React, { Component, ReactNode } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";

import classesServices from "../../services/classesServices";
import subjectsServices from "../../services/subjectsServices";
import chaptersServices from "../../services/chaptersServices";
import conceptsServices from "../../services/conceptsServices";
import subSubjectServices from "../../services/subSubjectsServices";

import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import {
  WithStyles,
  createStyles,
  Typography,
  Grid,
  Avatar,
  Button,
  Chip,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Tooltip,
  InputAdornment
} from "@material-ui/core";
import { SearchField, MyPATExpansionPanel } from "../../../common";
import { HomeOutlined as HomeIcon, CloseOutlined as CloseIcon } from "@material-ui/icons";
import CustomInfoIcon from "../../../common/CustomInfoIcon";
import AddFeedback from "../../../content-request/components/AddFeedback";
import { getPropertyValue, getUserType, iconsForSubjects, updateQueryParams } from "../../../../utils";
import { classNames } from "react-select/src/utils";
import { SectionFocusedContext, SectionFocusedContextValue } from "../../../common/MyPATBaseSection";
import { CONTENT_SPECIAL_PURPOSES, ChaptersAndConceptsForContent, USER_TYPE } from '../../../../constants/comman';
import { connect } from 'react-redux';
import SearchBarWithChips from '../../../course-Management/common/SearchBarWithChips';
import relevantExamsService from '../../services/relevantExamsService';
import { questionActions } from '../../reducers/questionCreateReducer';
import contentService from "../../services/contentService";
import { SECTIONS } from "../../helper/contentValidation";
import AddFeedbackPopup from "./AddFeedbackPopup";
import Switch from '@material-ui/core/Switch';

function arrowGenerator(color: string) {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.95em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent ${color} transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.95em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '1em 1em 0 1em',
        borderColor: `${color} transparent transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.95em',
      height: '3em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 1em 1em 0',
        borderColor: `transparent ${color} transparent transparent`,
      },
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.95em',
      height: '3em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 0 1em 1em',
        borderColor: `transparent transparent transparent ${color}`,
      },
    },
  };
}


const styles = (theme: Theme) =>
  createStyles({
    purple: {
      border: 'solid 1px #78d2a7',
      background: 'rgb(255 255 255)',
      width: '25px',
      height: '25px',
      margin: '0 8px 0 0',
      fontSize: '10px',
      color: '#1d7dea',
      // display: 'inline-block'
    },
    checkbox: {
      padding: '5px 0'
    },
    clickable: {
      cursor: 'pointer'
    },
    disabledEntity: {
      color: '#666666 !important',
      cursor: 'not-allowed !important',
      pointerEvents: 'none',
      opacity: 0.5
    },
    blueColor: {
      color: '#1D7DEA'
    },
    redColor: {
      color: '#F21D1D'
    },
    conceptHeading: {
      fontWeight: 400,
      fontSize: '15px',
      margin: '24px 0'
    },
    feedbackContainer: {
      position: 'relative',
      '& .feedbackBlock': {
        top: -16,
        left: "100%",
        position: "absolute",
        marginLeft: 20,
        zIndex: 2
      }
    },
    checkBoxElement: {
      padding: '0px 7px',
      top: 0,
      width: 20,
      height: 20,
      '-moz-appearance': 'none',
      opacity: 1,
      color: 'rgb(204, 204, 204)',
      border: '1px solid #B2B2B2',
      borderRadius: 2,
      margin: '-4px 14px 0px 16px',
      '& svg': {
        fontSize: '1.5rem',
        fontFamily: '"Nunito", sans-serif',
        fill: '#979797',
        opacity: 0
      },
      '& span:nth-child(1)': {
        width: 24,
        zIndex: 9
      }
    },
    checkedCheckbox: {
      backgroundColor: '#1d7dea!important',
      border: '1px solid #1d7dea !important',
      borderRadius: 2,
      color: '#99a1a7',
      '&::after': {
        content: "''",
        fontSize: 14,
        position: 'absolute',
        top: 1,
        left: 6,
        width: 4,
        height: 10,
        border: 'solid #fff',
        borderWidth: '0 2px 2px 0',
        transform: 'rotate(45deg)'
      },
      '&:hover': {
        backgroundColor: '#1d7dea'
      }
    },
    entityContainer: {
      cursor: 'pointer',
      '&>*': {
        marginRight: '5px'
      }
    },
    primaryColor: {
      color: 'rgb(29 125 234)'
    },
    mb2x: {
      marginBottom: theme.spacing.unit * 2,
    },
    p1x: {
      padding: theme.spacing.unit * 2,
    },

    cardHeading: {
      fontWeight: 400,
      fontSize: 18,
    },
    requiredHeading: {
      color: theme.palette.secondary.main,
    },
    borderBox: {
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      padding: "24px 18px",
      marginTop: 0,
      width: '100%',
    },

    conceptCode: {
      width: "auto",
      border: "1px solid",
      borderRadius: 15,
      background: "rgb(220, 218, 218)",
      textAlign: "center",
      padding: "0px 10px",
    },

    avatarBig: {
      height: 100,
      width: 100,
      margin: "0 auto",
      backgroundColor: "#F7FAFB",
      border: "2px solid #D2E1E5",
    },
    searchConceptRoot: {
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      padding: `0 ${theme.spacing.unit}px`,
      marginBottom: 15,
    },
    searchConceptBox: {
      display: 'flex',
      // borderBottom: `1px solid ${theme.palette.grey[300]}`,
      // padding: "24px 18px",
      paddingBottom: theme.spacing.unit * 3,
      position: "relative",
      // "&:after": {
      //   content: '"OR"',
      //   position: "absolute",
      //   bottom: 0,
      //   left: "50%",
      //   transform: "translate(-50%, 50%)",
      //   backgroundColor: theme.palette.grey[300],
      //   borderRadius: "50%",
      //   height: theme.spacing.unit * 3,
      //   width: theme.spacing.unit * 3,
      //   padding: theme.spacing.unit / 2,
      //   boxSizing: "content-box",
      //   fontStyle: "italic",
      //   fontFamily: theme.typography.fontFamily,
      //   fontSize: theme.typography.fontSize,
      //   lineHeight: 1.65,
      //   color: theme.palette.text.secondary,
      // },
    },
    exploreConceptBox: {
      padding: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 3,
      "& button": {
        backgroundColor: theme.palette.common.white,
      },
    },

    breadcrumb: {
      listStyle: "none",
      display: "inline-flex",
      paddingLeft: 0,
      margin: 0,
      "& li": {
        ...theme.typography.caption,
        display: "inline-block",
        cursor: "pointer",
        marginRight: theme.spacing.unit / 2,
        "&:after": {
          content: '">"',
          marginLeft: theme.spacing.unit / 2,
        },
        "&:only-child": {
          "&:after": {
            display: "none",
          },
        },
        "&:last-child": {
          "&:after": {
            display: "none",
          },
        },
      },
    },
    selectedBreadCrumb: {
      listStyle: "none",
      // display: "flex",
      alignItems: "center",
      paddingLeft: 0,
      margin: 0,
      marginBottom: 20,
      "& li": {
        ...theme.typography.body2,
        display: "inline-block",
        marginRight: 5,
        marginTop: 10,
        "&:after": {
          content: '">"',
          marginLeft: theme.spacing.unit / 2,
        },
        "&:only-child": {
          "&:after": {
            display: "none",
          },
        },
        "&:last-child": {
          "&:after": {
            display: "none",
          },
        },
      },
    },
    chipLabel: {
      overflow: "hidden",
      marginRight: "16px",
      maxWidth: "200px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "inline-block",
    },
    chipRoot: {
      maxWidth: "80%",
    },
    chipItem: {
      "& > div": {
        margin: '10px 5px',
        fontSize: 14,
        // padding: '20px 0'
      },
      "&:after": {
        display: "none",
      },
    },
    suggestContainer: {
      position: "relative",
    },
    suggestList: {
      position: "absolute",
      top: "34px",
      left: "0",
      background: "#fff",
      boxShadow: "0px 0px 2px #ccc",
      padding: 0,
      zIndex: 10,
      listStyleType: "none",
      marginTop: 0,
      width: "100%",
    },
    suggestItem: {
      padding: theme.spacing.unit,
      paddingBottom: theme.spacing.unit + 4,
      cursor: "pointer",
      zIndex: 11,
      "&::after": {
        content: "",
        display: "table",
        clear: "both",
      },
    },
    disabledSuggestion: {
      color: "#666",
      cursor: "not-allowed",
    },
    mybtnGroup: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "50% 50%",
      "& >div:nth-of-type(2)": {
        display: 'flex',
        flexDirection: 'row-reverse',
      },
      "& button": {
        height: "23px",
        textAlign: "center",
        marginBottom: "-10px",
        display: 'block',
        fontSize: '12px',
        backgroundColor: '#1d7dea',
        color: '#fff',
        float: 'none',
        border: 'none',
        borderRadius: '30px',
        '& >span:nth-of-type(1)': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        },
        '&:hover': {
          backgroundColor: '#1d7dea',
          color: '#fff',
        }
      },
    },
    suggestBtn: {
      float: "right",
      marginRight: "10px",
      height: "30px",
    },
    selectedConcept: {
      background: `${theme.palette.primary.main} !important`,
    },
    filterChip: {
      whiteSpace: "nowrap",
      borderRadius: 32,
      verticalAlign: "middle",
      justifyContent: "center",
      textDecoration: "none",
      backgroundColor: "transparent",
      margin: "8px 12px 20px 4px",
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 16,
      lineHeight: "20px",
      alignItems: "center",
      color: '#1d7dea',
      border: '1px solid #1d7dea',
      height: 'auto',
      '& svg': {
        fill: '#1d7dea',
      },
      '&>span': {
        whiteSpace: "pre-wrap",
        padding: "5px 12px",
      }
    },
    customDivider: {
      marginTop: 12,
      marginBottom: 12,
      backgroundColor: "#1D7DEA",
      "&:nth-of-type(2)": {
        backgroundColor: "#67BF02",
      },
    },
    formControl: {
      // margin: theme.spacing.unit * 3,
    },
    group: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      "& label": {
        marginLeft: 0,
        "&:nth-of-type(1)": {
          marginRight: 0,
        },
      },
    },
    dialogHeading: {
      fontSize: "14px",
      lineHeight: "22px",
      color: "#333",
      display: "block",
      fontWeight: 600,
    },
    Note: {
      fontSize: "14px",
      lineHeight: "22px",
      color: "#333",
      fontWeight: 600,
    },
    dialogSubheading: {
      fontSize: "14px",
      lineHeight: "22px",
      color: "#666",
    },
    customLabel: {
      marginRight: "5px",
    },
    arrowPopper: arrowGenerator(theme.palette.grey[700]),
    arrow: {
      position: 'absolute',
      fontSize: 6,
      width: '3em',
      height: '3em',
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: 0,
        height: 0,
        borderStyle: 'solid',
      },
    },
    bootstrapPopper: arrowGenerator(theme.palette.common.black),
    bootstrapTooltip: {
      backgroundColor: theme.palette.common.black,
    },
    bootstrapPlacementBottom: {
      margin: '8px 0',
    },
    feedbackHighlight: {
      cursor: 'pointer',
      '&:hover': {
        color: '#1d7dea',
      }
    },
    conceptIcon: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '& img': {
        margin: '0 7px 0 0px',
      },
    },
    conceptSpacing: {
      padding: '5px 0 !important',
    },
    conceptContainer: {
      maxHeight: '300px',
      overflow: 'auto',
      width: '100%',
    },
    customDisable: {
      opacity: 0.6,
      pointerEvents: 'none',
    },
    mutedText: {
      color: '#999',
    },
    searchBarChips: {
      height: 'auto',
      '&>div:nth-of-type(1)': {
        border: "1px solid #dfdfdf",
        borderRadius: 4,
        padding: '0 5px',
        '&>div:nth-of-type(1)': {
          '&>div:nth-of-type(1)': {
            '&>div:nth-of-type(1)': {
              '&>div:nth-of-type(1)': {
                overflow: 'initial',
              }
            }
          }
        }
      },
      '& svg': {
        cursor: 'pointer'
      }
    },
    emptyContainer: {
      textAlign: 'center',
      margin: '30px auto',
      '> *': {
        margin: 0
      }
    },
    rowBox: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    w50: {
      width: '50%',
    },
    w100: {
      width: '100%',
    },
    pR10: {
      paddingRight: '10px',
    },
    snapScreen: {
      '& img': {
        margin: '45px auto 15px',
        display: 'block',
      },
      '& h6': {
        fontSize: '18px',
        fontWeight: 600,
        color: '#333333',
        marginTop: 0,
        marginBottom: '4px',
        textAlign: 'center',
      },
      '& p': {
        fontSize: '16px',
        fontWeight: 400,
        color: '#333333',
        marginBottom: 0,
        textAlign: 'center',
      }
    },
    iOSSwitchBase: {
      '&$iOSChecked': {
        color: theme.palette.common.white,
        '& + $iOSBar': {
          backgroundColor: '#52d869',
        },
      },
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.sharp,
      }),
    },
    iOSChecked: {
      transform: 'translateX(18px)',
      '& + $iOSBar': {
        opacity: 1,
        border: 'none',
      },
    },
    iOSBar: {
      borderRadius: 13,
      width: 44,
      height: 22,
      marginTop: -11,
      marginLeft: -20,
      border: 'solid 1px',
      borderColor: '#999',
      backgroundColor: '#999',
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    iOSIcon: {
      width: 20,
      height: 20,
    },
    iOSIconChecked: {
      boxShadow: theme.shadows[1],
    },
  });




type ActiveMode = "primary" | "secondary";
interface AddConceptOrChapterProps extends WithStyles<typeof styles> {
  isRequired: boolean;
  customHeading: ReactNode;
  sectionId?: string;
  defaultExpanded: boolean;
  panelProps: any;
  formData: any[];
  handleFormChange: Function;
  error: boolean;
  errorText: string;
  courseId?: string;
  clientId?: string;
  allowSecondarySubjects: boolean;
  secondarySubjects: any;
  handleSecondarySubjectChange: any;
  isDisable: boolean;
  showWithoutExpansionPanel?: boolean;
  tag: string,
  openFeedback: boolean,
  addFeedback: Function,
  replyFeedback: Function,
  closeFeedback: Function,
  resolveFeedback: Function,
  clickedfeedbackData: any,
  addNewFeedback: Function,
  questionIndex?: number,
  selectedIndex: number,
  questionId?: string;
  reInitialiseValues?: boolean;
  authorType?: string;
  isTypeParagraph?: boolean;
  customDisabled: boolean;
  contentType?: string;
  setConcepts: Function,
  concepts: any[];
  goalMandatory: boolean;
  setActiveGoals: Function;
  activeGoals: any;
  updateRelevantExam: boolean;
  setSelectedGoals: Function;
  setSyllabusExams: Function;
  setBenchmarkingUpdate: Function;
  questionSpecialPurposes: any;
  syllabusExams: any;
  handleCourseChange?: Function;
  activeValidationFeedbackSection?: string;
  activeValidationFeedbackData?: number;
  handleAddCommentInFeedback?: Function;
  createNewValidationFeedback?: Function;
  selectedGoals: any;
  populateQuestionSyllabus: any;
  data: any;
  alreadyAddedQuestions: any;
  autoPopulateConcepts: any;
  location: any;
  history: any;
  match: any;
  handleUpdateRelevantExam: Function;
}
// type ENTITIES = 'classes' | 'subjects' | 'subSubjects' | 'chapters' | 'concepts'
enum ENTITIES {
  CLASSES = 'classes',
  SUBJECTS = 'subjects',
  SUB_SUBJECTS = 'subSubjects',
  CHAPTERS = 'chapters',
  CONCEPTS = 'concepts'
}

interface OPENED_ENTITIES { // Represents which entity are open
  classId: string;
  subjectId: string;
  subSubjectId: string;
  chapterId: string;
  conceptId: string;
}

const ALL_CLOSED_ENTITIES_STATE: OPENED_ENTITIES = {
  classId: '',
  subjectId: '',
  subSubjectId: '',
  chapterId: '',
  conceptId: '',
}

interface AddConceptOrChapterState {
  primary: {
    classes: any[];
    subjects: any[];
    subSubjects: any[];
    chapters: any[];
    concepts: any[];
    classId: {
      _id: string;
      name: string;
    };
    subjectId: {
      _id: string;
      name: string;
      checked?: boolean;
    };
    subSubjectId: {
      _id: string;
      name: string;
      checked?: boolean;
    };
    chapterId: {
      _id: string;
      name: string;
      checked?: boolean;
    };
    activeItem:
    | string
    | "classes"
    | "subjects"
    | "subSubjects"
    | "chapters"
    | "concepts";
    activeItemSet: any[];
    elasticConceptList: any[];
    suggestedConcept: any[];
    showSuggestedConcept: boolean;
    typeMaster: boolean;
    searchValue: string;
    currentlyActiveIds: Set<string>;
    openedEntities: OPENED_ENTITIES;
  };
  secondary: {
    classes: any[];
    subjects: any[];
    subSubjects: any[];
    chapters: any[];
    concepts: any[];
    classId: {
      _id: string;
      name: string;
    };
    subjectId: {
      _id: string;
      name: string;
      checked?: boolean;
    };
    subSubjectId: {
      _id: string;
      name: string;
      checked?: boolean;
    };
    chapterId: {
      _id: string;
      name: string;
      checked?: boolean;
    };
    activeItem:
    | string
    | "classes"
    | "subjects"
    | "subSubjects"
    | "chapters"
    | "concepts";
    activeItemSet: any[];
    elasticConceptList: any[];
    suggestedConcept: any[];
    showSuggestedConcept: boolean;
    typeMaster: boolean;
    searchValue: string;
    currentlyActiveIds: Set<string>;
    openedEntities: OPENED_ENTITIES;
  };
  currentlyActiveMode: ActiveMode;
  arrowRef: any,
  searchStr: string;
  isDataLoaded: boolean;
  selectedGoalList: any[];
  goalListing: any[];
  isConceptAutoPopulateChecked: boolean;
  studentDetails: any;
}

class AddConceptOrChapter extends Component<
  AddConceptOrChapterProps,
  AddConceptOrChapterState
> {
  debouncedSearchSuggestion: Function;
  constructor(props: AddConceptOrChapterProps) {
    super(props);
    this.state = {
      primary: {
        classes: [],
        subjects: [],
        subSubjects: [],
        chapters: [],
        concepts: [],
        classId: {
          _id: "",
          name: "",
        },
        subjectId: {
          _id: "",
          name: "",
        },
        subSubjectId: {
          _id: "",
          name: "",
        },
        chapterId: {
          _id: "",
          name: "",
        },
        activeItem: "classes",
        activeItemSet: [],
        elasticConceptList: [],
        suggestedConcept: [],
        showSuggestedConcept: false,
        typeMaster: true,
        searchValue: "",
        currentlyActiveIds: new Set(), // holds ids of all the checked entities (subject or chapter or concepts)
        openedEntities: ALL_CLOSED_ENTITIES_STATE // holds the id of opened items at every level
      },
      secondary: {
        classes: [],
        subjects: [],
        subSubjects: [],
        chapters: [],
        concepts: [],
        classId: {
          _id: "",
          name: "",
        },
        subjectId: {
          _id: "",
          name: "",
        },
        subSubjectId: {
          _id: "",
          name: "",
        },
        chapterId: {
          _id: "",
          name: "",
        },
        activeItem: "classes",
        activeItemSet: [],
        elasticConceptList: [],
        suggestedConcept: [],
        showSuggestedConcept: false,
        typeMaster: true,
        searchValue: "",
        currentlyActiveIds: new Set(), // holds ids of all the checked entities (subject or chapter or concepts)
        openedEntities: ALL_CLOSED_ENTITIES_STATE // holds the id of opened items at every level
      },
      isDataLoaded: false,
      currentlyActiveMode: "primary",
      arrowRef: null,
      searchStr: '',
      selectedGoalList: [],
      goalListing: [],
      isConceptAutoPopulateChecked: false,
      studentDetails: {}
    };

    this.handleNextClick = this.handleNextClick.bind(this);
    this.showSuggestedConcept = this.showSuggestedConcept.bind(this);
    this.searchSuggestion = this.searchSuggestion.bind(this);
    this.debouncedSearchSuggestion = _.debounce(this.searchSuggestion, 1000);
    this.choosedConcept = this.choosedConcept.bind(this);
    if(this.props.populateQuestionSyllabus) {
      this.props.populateQuestionSyllabus.current = this.populateQuestionSyllabus;
    }
    if(this.props.autoPopulateConcepts) {
      this.props.autoPopulateConcepts.current = this.autoPopulateConcepts;
    }
  }

  handleArrowRef = (node: any) => {
    this.setState({
      arrowRef: node,
    });
  };

  handleSearchOnChange = (value: string) => {
    this.setState({
      searchStr: value
    }, () => this.debouncedSearchSuggestion(value))
  }

  handleOpenEntity = async (mode: ActiveMode, level: ENTITIES, item: any) => {
    try {
      const { _id, name } = item;
      await this.handleNextClick(level, _id, name, '')
      this.setState(prevState => {
        const modeState = { ...prevState[mode] };
        let newOpenedEntities = { ...modeState.openedEntities };
        if (level === ENTITIES.CLASSES) {
          newOpenedEntities.classId = newOpenedEntities.classId === _id ? '' : _id;
          newOpenedEntities.subjectId = '';
          newOpenedEntities.subSubjectId = '';
          newOpenedEntities.chapterId = '';
          newOpenedEntities.conceptId = '';
        } else if (level === ENTITIES.SUBJECTS) {
          newOpenedEntities.subjectId = newOpenedEntities.subjectId === _id ? '' : _id;
          newOpenedEntities.subSubjectId = '';
          newOpenedEntities.chapterId = '';
          newOpenedEntities.conceptId = '';
        } else if (level === ENTITIES.SUB_SUBJECTS) {
          newOpenedEntities.subSubjectId = newOpenedEntities.subSubjectId === _id ? '' : _id;
          newOpenedEntities.chapterId = '';
          newOpenedEntities.conceptId = '';
        } else if (level === ENTITIES.CHAPTERS) {
          newOpenedEntities.chapterId = newOpenedEntities.chapterId === _id ? '' : _id;
          newOpenedEntities.conceptId = '';
        } else if (level === ENTITIES.CONCEPTS) {
          newOpenedEntities.conceptId = newOpenedEntities.conceptId === _id ? '' : _id;
        }
        modeState.openedEntities = newOpenedEntities;
        return {
          ...prevState,
          [mode]: modeState
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  checkForFeedback() {
    let { clickedfeedbackData, questionId } = this.props;
    if (this.props.selectedIndex !== undefined) {
      return ((_.isEmpty(clickedfeedbackData) && this.props.openFeedback && this.props.tag === "concept" && this.props.selectedIndex === this.props.questionIndex) || (!_.isEmpty(clickedfeedbackData) && this.props.openFeedback && clickedfeedbackData.tag === "concept" && questionId === clickedfeedbackData.contentId))
    } else {
      return this.props.openFeedback && this.props.tag === "concept"

    }
  }

  handleInitiallySelected = (mode: ActiveMode, formData: any) => {
    const { primary, secondary } = this.state;
    let newCurrentlyActiveIds = new Set();
    _.forEach(formData, (formD: any, formI: number) => {
      if (!formD.subjectId) {
        return "";
      }
      if (formD.checked || formD.subjectId.checked) {
        newCurrentlyActiveIds.add(formD.subjectId._id);
      }
      _.forEach(formD.subSubjects, (ssD: any, ssI: number) => {
        if (!ssD.subSubjectId) {
          return "";
        }
        if (ssD.checked || ssD.subSubjectId.checked) {
          newCurrentlyActiveIds.add(ssD.subSubjectId._id);
        }
        _.forEach(ssD.chapters, (chD: any, chI: number) => {
          if (!chD.chapterId) {
            return "";
          }
          if (chD.checked || chD.chapterId.checked) {
            newCurrentlyActiveIds.add(chD.chapterId && chD.chapterId._id);
          }
          _.forEach(chD.concepts, (coD: any, coI: number) => {
            if (!coD.conceptId) {
              return "";
            }
            if (coD.checked || coD.conceptId.checked) {
              newCurrentlyActiveIds.add(coD.conceptId._id);
            }
            // coD.checked = true;
            // newCurrentlyActiveIds.add(coD.conceptId._id);
          });
        });
      });
    });

    this.setState((prevState) => ({
      ...prevState,
      [mode]: {
        ...prevState[mode],
        currentlyActiveIds: newCurrentlyActiveIds,
      },
      isDataLoaded: !!formData.length,
    }));

  };

  fetchClasses = (mode: 'primary' | 'secondary') => {
    if (!this.props.goalMandatory) {
      classesServices.list().then((classes: any) =>
        this.setState((prevState) => ({
          ...prevState,
          [mode]: { ...prevState[mode], classes },
        }))
      );
    }
  }
  fetchGoalWiseClasses(loadClassSubjects = false) {
    if (this.props.goalMandatory) {
      const { selectedGoalList: activeGoals } = this.state;
      const goalIdListing = activeGoals.map(goal => goal.id);
      classesServices.getGaolWiseConceptAndChapter(goalIdListing).then((res: any) => {
        if (res.statusCode === 200) {
          let classes = res.responseObject.classes || [];
          if (getUserType(USER_TYPE.STUDENT)) {
            const activeClassId = getPropertyValue(this.state.studentDetails, 'class.classId');
            classes = classes.filter((classDetails: any) => classDetails._id === activeClassId);
          }
          this.setState((prevState: any) => ({
            ...prevState,
            primary: { ...prevState.primary, classes, openedEntities: ALL_CLOSED_ENTITIES_STATE },
            secondary: { ...prevState.secondary, classes, openedEntities: ALL_CLOSED_ENTITIES_STATE },
          }))
            loadClassSubjects && (classes || []).forEach((data:any)=>{
                this.handleNextClick(ENTITIES.CLASSES,data._id,data.name,'')
            })
        }
      }
      );
    }
  }

  componentDidMount() {
    this.setState({
      selectedGoalList: [],
    });
    const { formData, allowSecondarySubjects, secondarySubjects, goalMandatory, selectedGoals, questionId = '' } = this.props;
    if (selectedGoals && selectedGoals[questionId]) {
      this.setState({ selectedGoalList: this.props.selectedGoals[this.props.questionId || ''] || [] },
        () => {
          this.fetchGoalWiseClasses(getUserType(USER_TYPE.STUDENT));
        }
      );
    }
    this.handleInitiallySelected("primary", formData);
    this.fetchClasses('primary')
    if (allowSecondarySubjects) {
      this.fetchClasses('secondary')
      this.handleInitiallySelected("secondary", secondarySubjects);
    }
    if (goalMandatory) {
      if (this.props.questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE)) {
        contentService.getSpecialPurposeCourses(CONTENT_SPECIAL_PURPOSES.FTRE).then((res) => {
          const dataMap = res.map((data: any)=>({
              id: data._id,
              value: data._id,
              label: data.name,
          }));
          this.setState({ goalListing: dataMap });
        });
        return;
      }
      relevantExamsService.getRelevantExams().then((goalListing: any) => {
        this.transformGoals(goalListing);
      });
    }
    const {location} = this.props;
    const searchParams = new URLSearchParams(location.search);
    const autoFillConceptToggleValue = (searchParams.get('autoFillConcepts') === 'true');
    this.setState((prevState: any, ) => ({
      ...prevState,
      isConceptAutoPopulateChecked: autoFillConceptToggleValue,
    }), () => {
      if(autoFillConceptToggleValue) {
        this.autoPopulateConcepts();
      }
    });
  }

  componentDidUpdate(prevProps: AddConceptOrChapterProps, prevState: AddConceptOrChapterState) {
    const { currentlyActiveMode } = this.state;
    const { searchValue, typeMaster } = this.state[currentlyActiveMode];
    const { currentlyActiveMode: prevActiveMode } = prevState;
    const { typeMaster: prevTypeMaster } = prevState[prevActiveMode];
    if (prevTypeMaster != typeMaster) {
      if (searchValue) {
        this.searchSuggestion(searchValue);
      }
    }
    const { formData: prevFormData } = prevProps;
    const { reInitialiseValues, formData, allowSecondarySubjects, secondarySubjects } = this.props;
    if (reInitialiseValues && JSON.stringify(prevFormData) !== JSON.stringify(formData)) {
      this.handleInitiallySelected("primary", formData);
      if (allowSecondarySubjects) {
        this.handleInitiallySelected("secondary", secondarySubjects);
      }
    }
    if (!this.state.isDataLoaded && !prevFormData.length && JSON.stringify(prevFormData) !== JSON.stringify(formData)) {
      this.handleInitiallySelected("primary", formData);
      allowSecondarySubjects && this.handleInitiallySelected("secondary", secondarySubjects);
    }
  }

  onTypeMasterClick = () => {
    const { currentlyActiveMode } = this.state;
    this.setState((prevState) => ({
      ...prevState,
      [currentlyActiveMode]: {
        ...prevState[currentlyActiveMode],
        typeMaster: !prevState[currentlyActiveMode].typeMaster,
      },
    }));
  };

  handleNextClick(
    activeItem: string,
    activeItemId: string,
    activeItemName: string,
    conceptCode: string
  ) {
    const { currentlyActiveMode, selectedGoalList } = this.state;
    const { selectedGoalList: activeGoals } = this.state;
    const { classId } = this.state[currentlyActiveMode];
    const { goalMandatory } = this.props;
    const courseTypeIds = activeGoals.map(goal => goal && goal.id);

    return new Promise(resolve => {
      switch (activeItem) {
        case "classes": {
          const goalListPromise = goalMandatory ? subjectsServices.listByGradeByGoal([activeItemId], courseTypeIds) : subjectsServices.listByGrade(activeItemId);
          goalListPromise.then((subjects: any) => {
            this.setState((prevState) => ({
              ...prevState,
              [currentlyActiveMode]: {
                ...prevState[currentlyActiveMode],
                subjects,
                classId: {
                  _id: activeItemId,
                  name: activeItemName,
                },
                activeItem: "subjects",
                activeItemSet: [
                  ...prevState[currentlyActiveMode].activeItemSet,
                  { _id: activeItemId, name: activeItemName, type: activeItem },
                ],
              },
            }));
            resolve(subjects);
          });
          break;
        }
        case "subjects": {
          const goalListPromise = goalMandatory ? subSubjectServices.listBySubjectsByGoal([activeItemId], courseTypeIds) : subSubjectServices.listBySubjects(activeItemId, classId._id);
          goalListPromise.then((subSubjects: any) => {
            this.setState((prevState) => ({
              ...prevState,
              [currentlyActiveMode]: {
                ...prevState[currentlyActiveMode],
                subSubjects,
                subjectId: {
                  _id: activeItemId,
                  name: activeItemName,
                },
                activeItem: "subSubjects",
                activeItemSet: [
                  ...prevState[currentlyActiveMode].activeItemSet,
                  { _id: activeItemId, name: activeItemName, type: activeItem },
                ],
              },
            }));
            resolve(subSubjects)
          });
          break;
        }
        case "subSubjects": {
          const goalListPromise = goalMandatory ? chaptersServices.listBySubSubjectByGoal([activeItemId], courseTypeIds) : chaptersServices.listBySubSubject(activeItemId, classId._id);
          goalListPromise
            .then((chapters: any) => {
              this.setState((prevState) => ({
                ...prevState,
                [currentlyActiveMode]: {
                  ...prevState[currentlyActiveMode],
                  chapters,
                  subSubjectId: {
                    _id: activeItemId,
                    name: activeItemName,
                  },
                  activeItem: "chapters",
                  activeItemSet: [
                    ...prevState[currentlyActiveMode].activeItemSet,
                    { _id: activeItemId, name: activeItemName, type: activeItem },
                  ],
                },
              }));
              resolve(chapters)
            });
          break;
        }
        case "chapters": {
          const goalListPromise = goalMandatory ? conceptsServices.listByChapterByGoal([activeItemId], courseTypeIds) : conceptsServices.listByChapter(activeItemId, classId._id);

          goalListPromise
            .then((concepts: any) => {
              this.setState((prevState) => ({
                ...prevState,
                [currentlyActiveMode]: {
                  ...prevState[currentlyActiveMode],
                  concepts,
                  chapterId: {
                    _id: activeItemId,
                    name: activeItemName,
                  },
                  activeItem: "concepts",
                  activeItemSet: [
                    ...prevState[currentlyActiveMode].activeItemSet,
                    { _id: activeItemId, name: activeItemName, type: activeItem },
                  ],
                },
              }));
              resolve(concepts)
            });
        }
      }
    })
  }

  handleBreadcrumbClick = (
    mode: ActiveMode,
    activeItem: string,
    index: any
  ) => {
    let newActiveItemSet = this.state[mode].activeItemSet;
    newActiveItemSet.length = index + 1;
    switch (activeItem) {
      case "classes": {
        return this.setState((prevState) => ({
          ...prevState,
          [mode]: {
            ...prevState[mode],
            activeItemSet: newActiveItemSet,
            activeItem: "subjects",
          },
        }));
      }
      case "subjects": {
        return this.setState((prevState) => ({
          ...prevState,
          [mode]: {
            ...prevState[mode],
            activeItemSet: newActiveItemSet,
            activeItem: "subSubjects",
          },
        }));
      }
      case "subSubjects": {
        return this.setState((prevState) => ({
          ...prevState,
          [mode]: {
            ...prevState[mode],
            activeItemSet: newActiveItemSet,
            activeItem: "chapters",
          },
        }));
      }
      case "chapters": {
        return this.setState((prevState) => ({
          ...prevState,
          [mode]: {
            ...prevState[mode],
            activeItemSet: newActiveItemSet,
            activeItem: "concepts",
          },
        }));
      }
      default: {
        return this.setState((prevState) => ({
          ...prevState,
          [mode]: {
            ...prevState[mode],
            activeItemSet: newActiveItemSet,
            activeItem: "classes",
          },
        }));
      }
    }
  };

  generateFormData(item?: any, params?: any) {
    let subjectId: any, chapterId: any, subSubjectId: any, conceptId: any;
    let { currentlyActiveMode } = this.state;
    const { classId } = this.state[currentlyActiveMode];
    subjectId = { _id: item.subject.id, name: item.subject.name };
    subSubjectId = { _id: item.subsubject.id, name: item.subsubject.name };
    chapterId = { _id: item.chapter.id, name: item.chapter.name };
    conceptId = { _id: item._id, name: item.name };
    if (params.type === "subject") {
      subjectId.checked = true;
    }
    if (params.type === "subsubject") {
      subSubjectId.checked = true;
    }
    if (params.type === "chapter") {
      chapterId.checked = true;
    }
    if (params.type === "concept") {
      conceptId.checked = true;
    }

    return {
      subjectId,
      subSubjects: [
        {
          subSubjectId,
          chapters: [
            {
              chapterId,
              concepts: [
                {
                  conceptId,
                  conceptCode: item.conceptCode,
                  classId,
                },
              ],
            },
          ],
        },
      ],
    };
  }

  showSuggestedConcept(action: boolean) {
    if (action) {
      this.setState((prevState) => {
        const activeMode = prevState.currentlyActiveMode;
        return {
          ...prevState,
          [activeMode]: {
            ...prevState[activeMode],
            showSuggestedConcept: true,
            suggestedConcept: [],
          },
        };
      });
    } else {
      setTimeout(() => {
        this.setState((prevState) => {
          const activeMode = prevState.currentlyActiveMode;
          return {
            ...prevState,
            [activeMode]: {
              ...prevState[activeMode],
              showSuggestedConcept: false,
              suggestedConcept: [],
            },
          };
        });
      }, 200);
    }
  }

  searchSuggestion(val: string) {
    const { courseId, clientId, goalMandatory } = this.props;
    const { selectedGoalList: activeGoals } = this.state;
    let type = "other";
    const { currentlyActiveMode } = this.state;
    const { typeMaster } = this.state[currentlyActiveMode];
    if (typeMaster) {
      type = "master";
    }
    this.setState((prevState) => {
      const activeMode = prevState.currentlyActiveMode;
      return {
        ...prevState,
        [activeMode]: {
          ...prevState[activeMode],
          searchValue: val,
        },
      };
    });

    if (val) {
      const courseTypeIds = activeGoals.map(goal => goal.id);
      const searchPromise = goalMandatory ? conceptsServices.listElasticByGoals(val, courseTypeIds, type) : conceptsServices.listElastic(courseId, type, val, clientId);

      searchPromise
        .then((suggestedConcept) => {
          const { currentlyActiveMode } = this.state;

          // set disabled: true if the concept is present in otherActiveIds
          const primaryActiveIds = this.state.primary.currentlyActiveIds;
          const secondaryActiveIds = this.state.secondary.currentlyActiveIds;

          const finalSuggestedConcepts = suggestedConcept.map(
            (suggestion: any) => {
              const { conceptId } = suggestion;
              if (
                conceptId &&
                (primaryActiveIds.has(conceptId) ||
                  secondaryActiveIds.has(conceptId))
              ) {
                return { ...suggestion, disabled: true };
              }
              return suggestion;
            }
          );

          if (typeMaster) {
            this.setState((prevState) => {
              return {
                ...prevState,
                [currentlyActiveMode]: {
                  ...prevState[currentlyActiveMode],
                  showSuggestedConcept: true,
                  suggestedConcept: finalSuggestedConcepts,
                },
              };
            });
          } else {
            this.setState((prevState) => {
              const activeMode = prevState.currentlyActiveMode;
              return {
                ...prevState,
                [activeMode]: {
                  ...prevState[activeMode],
                  suggestedConcept: finalSuggestedConcepts,
                },
              };
            });
          }
        });
    }
  }

  choosedConcept(mode: "primary" | "secondary", cp: any) {
    // let { formData } = this.props;

    // remove disabled key from the cocenpt
    cp = _.omit(cp, ["disabled"]);
    let formData: any;
    if (mode === "primary") {
      formData = this.props.formData;
    } else {
      formData = this.props.secondarySubjects;
    }
    let newFormData: any = {
      subjectId: {
        _id: cp.subjectId,
        name: cp.subjectName,
      },
      subSubjects: [
        {
          subSubjectId: {
            _id: cp.subSubjectId,
            name: cp.subSubjectName,
          },
          chapters: [
            {
              chapterId: {
                _id: cp.chapterId,
                name: cp.chapterName,
              },
              concepts: [
                {
                  conceptId: {
                    _id: cp.conceptId,
                    name: cp.conceptName,
                    checked: true,
                  },
                  conceptCode: cp.conceptCode,
                  classId: {
                    _id: cp.classId,
                    name: cp.className,
                  },
                },
              ],
            },
          ],
        },
      ],
    };
    let sI: any, ssI: any, chI: any, cnI: any;

    let subject = _.filter(formData, (formD: any, formI: number) => {
      if (_.isEqual(cp.subjectId, _.get(formD, "subjectId._id"))) {
        sI = formI;
        return true;
      }

      return false;
    });

    let subSubject = _.filter(
      _.get(subject, "[0].subSubjects", []),
      (subSubjectD: any, subSubjectI: number) => {
        if (
          _.isEqual(cp.subSubjectId, _.get(subSubjectD, "subSubjectId._id"))
        ) {
          ssI = subSubjectI;
          return true;
        }

        return false;
      }
    );

    let chapter = _.filter(
      _.get(subSubject, "[0].chapters", []),
      (chapterD: any, chapterI: number) => {
        if (_.isEqual(cp.chapterId, _.get(chapterD, "chapterId._id"))) {
          chI = chapterI;
          return true;
        }

        return false;
      }
    );

    let concept = _.filter(
      _.get(chapter, "[0].concepts", []),
      (conceptD: any, conceptI: number) => {
        if (
          _.isEqual(cp.conceptId, _.get(conceptD, "conceptId._id")) &&
          _.isEqual(cp.classId, _.get(conceptD, "classId._id"))
        ) {
          cnI = conceptI;
          return true;
        }

        return false;
      }
    );

    if (concept.length > 0) {
      return;
    }

    if (sI > -1 && ssI > -1 && chI > -1 && !cnI) {
      if (!formData[sI].subSubjects[ssI].chapters[chI].concepts) {
        formData[sI].subSubjects[ssI].chapters[chI].concepts = [];
      }
      formData[sI].subSubjects[ssI].chapters[chI].concepts.push(
        newFormData.subSubjects[0].chapters[0].concepts[0]
      );
    } else if (sI > -1 && ssI > -1 && !chI && !cnI) {
      if (!formData[sI].subSubjects[ssI].chapters) {
        formData[sI].subSubjects[ssI].chapters = [];
      }
      formData[sI].subSubjects[ssI].chapters.push(
        newFormData.subSubjects[0].chapters[0]
      );
    } else if (sI > -1 && !ssI && !chI && !cnI) {
      if (!formData[sI].subSubjects) {
        formData[sI].subSubjects = [];
      }
      formData[sI].subSubjects.push(newFormData.subSubjects[0]);
    } else if (!sI && !ssI && !chI && !cnI) {
      formData.push(newFormData);
    }
    const { currentlyActiveMode } = this.state;

    if (this.state[currentlyActiveMode].showSuggestedConcept) {
      this.showSuggestedConcept(false);
    }

    // add to currentlyActiveIds
    this.toggleCurrentlyActiveItemId(mode, cp.conceptId, "add");

    this.setState({ searchStr: '' });

    if (mode === "primary") {
      return this.props.handleFormChange(formData);
    } else {
      return this.props.handleSecondarySubjectChange(formData);
    }
  }

  getMasterConcept = async (data: any) => {
    const { mode, ...params } = data;
    const concepts = await conceptsServices.getMaterConcept(params);
    let formData: any;
    if (mode === "primary") {
      formData = this.props.formData;
    } else {
      formData = this.props.secondarySubjects;
    }

    // Handle removing existing successors
    const concept = _.get(concepts, '[0]');
    const { id: itemId, type } = params;
    if (concept) {
      const existingSubject = (formData || []).find((subject: any) => subject.subjectId._id === concept.subject.id);
      const existingSubSubject = _.get(existingSubject, 'subSubjects', []).find((subSubject: any) => subSubject.subSubjectId._id === concept.subsubject.id);
      const existingChapters = _.get(existingSubSubject, 'chapters', []).find((chapter: any) => chapter.chapterId._id === concept.chapter.id);
      if (type === this.skipLastCharAndLowerCase(ENTITIES.SUBJECTS)) {
        if (existingSubject) {
          this.removeSuccessors(existingSubject, mode, type)
        }
      } else if (type === this.skipLastCharAndLowerCase(ENTITIES.SUB_SUBJECTS)) {
        if (existingSubSubject) {
          this.removeSuccessors(existingSubSubject, mode, type)
        }
      } else if (type === this.skipLastCharAndLowerCase(ENTITIES.CHAPTERS)) {
        if (existingChapters) {
          this.removeSuccessors(existingChapters, mode, type);
        }
      }
    }

    concepts.forEach((concept: any) => {
      this.addConceptMappingInForm(mode, concept, formData, params);
    });
    if (mode === "primary") {
      this.props.handleFormChange(formData);
    } else {
      this.props.handleSecondarySubjectChange(formData);
    }
  };

  skipLastCharAndLowerCase = (str: string) => {
    return str
      .substring(0, str.length - 1)
      .toLowerCase();
  }

  removeSuccessors = (
    item: any,
    mode: ActiveMode,
    level: string,
  ) => {
    if (level === this.skipLastCharAndLowerCase(ENTITIES.SUBJECTS)) {
      // current level is subject
      // remove checked from all subSubjects and recursively remove it's ancestors

      const subSubjects: any[] = [..._.get(item, 'subSubjects', [])];
      if (item.subSubjects) {
        item.subSubjects = [];
      }
      subSubjects.forEach((subSubject) => {
        if (subSubject.checked || subSubject.subSubjectId.checked) {
          this.toggleCurrentlyActiveItemId(mode, subSubject.subSubjectId._id, 'remove')
        }
        this.removeSuccessors(subSubject, mode, this.skipLastCharAndLowerCase(ENTITIES.SUB_SUBJECTS));
      })
    } else if (level === this.skipLastCharAndLowerCase(ENTITIES.SUB_SUBJECTS)) {
      // current level is sub subject
      // remove checked from all chapters and recursively remove it's ancestors
      const chapters: any[] = [..._.get(item, 'chapters', [])];
      if (item.chapters) {
        item.chapters = [];
      }
      chapters.forEach((chapter) => {
        if (chapter.checked || chapter.chapterId.checked) {
          this.toggleCurrentlyActiveItemId(mode, chapter.chapterId._id, 'remove')
        }
        this.removeSuccessors(chapter, mode, this.skipLastCharAndLowerCase(ENTITIES.CHAPTERS));
      })
    } else if (level === this.skipLastCharAndLowerCase(ENTITIES.CHAPTERS)) {
      // current level is chapters
      // remove checked from all concepts
      const concepts: any[] = [..._.get(item, 'concepts', [])];
      if (item.concepts) {
        item.concepts = [];
      }
      concepts.forEach((concept) => {
        if (concept.checked || concept.conceptId.checked) {
          this.toggleCurrentlyActiveItemId(mode, concept.conceptId._id, 'remove')
        }
      })
    }
  }

  // Runs fpr concepts and try to add it in formData at correct subject, subSubject, chapter
  addConceptMappingInForm = (
    mode: "primary" | "secondary",
    item: any,
    formData: any,
    params?: any
  ) => {
    let { classId } = this.state[mode];
    let subjectId: any, chapterId: any, subSubjectId: any, conceptId: any;
    subjectId = { _id: item.subject.id, name: item.subject.name };
    subSubjectId = { _id: item.subsubject.id, name: item.subsubject.name };
    chapterId = { _id: item.chapter.id, name: item.chapter.name };
    conceptId = { _id: item._id, name: item.name };
    const newFormData = this.generateFormData(item, params);
    if (!formData) {
      formData = [];
    }
    let sI: any, ssI: any, chI: any, cnI: any;

    let subject = _.filter(formData, (formD: any, formI: number) => {
      if (_.isEqual(subjectId._id, _.get(formD, "subjectId._id"))) {
        sI = formI;
        return true;
      }

      return false;
    });

    let subSubject = _.filter(
      _.get(subject, "[0].subSubjects", []),
      (subSubjectD: any, subSubjectI: number) => {
        if (
          _.isEqual(subSubjectId._id, _.get(subSubjectD, "subSubjectId._id"))
        ) {
          ssI = subSubjectI;
          return true;
        }

        return false;
      }
    );

    let chapter = _.filter(
      _.get(subSubject, "[0].chapters", []),
      (chapterD: any, chapterI: number) => {
        if (_.isEqual(chapterId._id, _.get(chapterD, "chapterId._id"))) {
          chI = chapterI;
          return true;
        }

        return false;
      }
    );

    let concept = _.filter(
      _.get(chapter, "[0].concepts", []),
      (conceptD: any, conceptI: number) => {
        if (
          _.isEqual(item._id, _.get(conceptD, "conceptId._id")) &&
          _.isEqual(classId._id, _.get(conceptD, "classId._id"))
        ) {
          cnI = conceptI;
          return true;
        }

        return false;
      }
    );

    if (item.length > 0) {
      return;
    }

    if (sI > -1 && ssI > -1 && chI > -1 && !cnI) {
      if (!formData[sI].subSubjects[ssI].chapters[chI].concepts) {
        formData[sI].subSubjects[ssI].chapters[chI].concepts = [];
      }
      formData[sI].subjectId = { ...newFormData.subjectId };
      formData[sI].subSubjects[ssI].subSubjectId = { ...newFormData.subSubjects[0].subSubjectId }
      formData[sI].subSubjects[ssI].chapters[chI].chapterId = { ...newFormData.subSubjects[0].chapters[0].chapterId }
      formData[sI].subSubjects[ssI].chapters[chI].concepts.push(
        newFormData.subSubjects[0].chapters[0].concepts[0]
      );
    } else if (sI > -1 && ssI > -1 && !chI && !cnI) {
      if (!formData[sI].subSubjects[ssI].chapters) {
        formData[sI].subSubjects[ssI].chapters = [];
      }
      formData[sI].subjectId = { ...newFormData.subjectId };
      formData[sI].subSubjects[ssI].subSubjectId = { ...newFormData.subSubjects[0].subSubjectId }
      formData[sI].subSubjects[ssI].chapters.push(
        newFormData.subSubjects[0].chapters[0]
      );
    } else if (sI > -1 && !ssI && !chI && !cnI) {

      if (!formData[sI].subSubjects) {
        formData[sI].subSubjects = [];
      }
      formData[sI].subjectId = { ...newFormData.subjectId };
      formData[sI].subSubjects.push(newFormData.subSubjects[0]);
    } else if (!sI && !ssI && !chI && !cnI) {
      formData.push(newFormData);
    }
  };

  resetAllConceptMappings = () => {
    if (this.props.isTypeParagraph) {
      const modes: ActiveMode[] = ['primary', 'secondary'];
      modes.forEach((mode: ActiveMode) => {
        const {
          subjectData,
          subSubjectData,
          chapterData,
          conceptData,
        } = this.getNewConceptMapping(mode);
        subjectData.forEach((element: any) => {
          this.removeConceptMapping(mode, 'subject', element[1]);
        });
        subSubjectData.forEach((element: any) => {
          this.removeConceptMapping(mode, 'subsubjects', element[2]);
        });
        chapterData.forEach((element: any) => {
          this.removeConceptMapping(mode, 'chapters', element[3]);
        });
        conceptData.forEach((element: any) => {
          this.removeConceptMapping(mode, 'concepts', element[4]);
        });
      });
    } else {
      const { allowSecondarySubjects } = this.props;
      this.setState(
        (prevState) => {
          const { primary, secondary } = prevState;
          const newPrimary = { ...primary };
          newPrimary.currentlyActiveIds = new Set();

          const newSecondary = { ...secondary };
          newSecondary.currentlyActiveIds = new Set();

          return {
            ...prevState,
            primary: newPrimary,
            secondary: newSecondary,
          };
        },
        () => {
          this.props.handleFormChange([]);
          if (allowSecondarySubjects) {
            this.props.handleSecondarySubjectChange([]);
          }
        }
      );
    }
  }

  removeConceptMapping = (mode: ActiveMode, type: string, item: any, updateConcepts?: boolean) => {
    let formData: any;
    if (mode === "primary") {
      formData = this.props.formData;
    } else {
      formData = this.props.secondarySubjects;
    }

    const levels: any = {
      subjects: 0,
      subsubjects: 1,
      chapters: 2,
      concepts: 3,
    };

    formData.forEach((formD: any, formI: number) => {
      if (!formD.subjectId) {
        return "";
      }
      if (formD.subjectId._id === item._id) {
        formData.splice(formI, 1);
      }
      if (levels[type.toLowerCase()] > 0) {
        formD.subSubjects.forEach((ssD: any, ssI: number) => {
          if (!ssD.subSubjectId) {
            return "";
          }
          if (ssD.subSubjectId._id === item._id) {
            formData[formI].subSubjects.splice(ssI, 1);
          }
          if (levels[type.toLowerCase()] > 1) {
            ssD.chapters.forEach((chD: any, chI: number) => {
              if (!chD.chapterId) {
                return "";
              }
              if (chD.chapterId && chD.chapterId._id === item._id) {
                formData[formI].subSubjects[ssI].chapters.splice(chI, 1);
              }
              if (levels[type.toLowerCase()] > 2) {
                chD.concepts.forEach((coD: any, coI: number) => {
                  if (!coD.conceptId) {
                    return "";
                  }
                  if (_.isEqual(coD.conceptId._id, item._id)) {
                    formData[formI].subSubjects[ssI].chapters[
                      chI
                    ].concepts.splice(coI, 1);

                    //if no other concept then remove subject
                    if (
                      formData[formI].subSubjects[ssI].chapters[chI].concepts
                        .length == 0
                    ) {
                      let c1 =
                        formData[formI].subSubjects[ssI].chapters.length == 1;
                      let c2 = formData[formI].subSubjects.length == 1;
                      if (c1 && c2) {
                        formData.splice(formI, 1);
                      }
                    }
                  }
                });
              }
            });
          }
        });
      }
    });
    this.toggleCurrentlyActiveItemId(mode, item._id, "remove");
    const conceptData = updateConcepts && this.updateConceptFormData(mode);
    const isConceptAvailable = conceptData && conceptData.length
    if (mode === "primary") {
      this.props.handleFormChange(formData, isConceptAvailable);
    } else {
      this.props.handleSecondarySubjectChange(formData);
    }
  };

  updateConceptFormData(mode: any): any {
    const { conceptData } = this.getNewConceptMapping(mode);
    this.updateConcepts(conceptData);
    return conceptData;
  }

  updateConcepts(conceptData: any) {
    let conceptAlreadyPresentInProps: any[] = [];
    let conceptPresentInFormData: any[] = [];
    let concepts: any[] = [];

    if (conceptData && conceptData.length) {
      conceptPresentInFormData = conceptData.map((item: any) => item[item.length - 1]._id);
    }

    if (this.props.concepts && this.props.concepts.length) {
      concepts = [...this.props.concepts];
      conceptAlreadyPresentInProps = concepts.map((item: any) => item.id);
    }

    let filteredConcepts = concepts.filter((item: any, index: number) => {
      return conceptPresentInFormData.includes(item.id)
    });

    conceptData.forEach((item: any) => {
      if (!conceptAlreadyPresentInProps.includes(item[item.length - 1]._id)) {
        filteredConcepts.push({ id: item[item.length - 1]._id, name: item[item.length - 1].name, _id: item[0]._id });
      }
    });
    this.props.setConcepts(filteredConcepts);
  }

  getNewConceptMapping = (mode: ActiveMode) => {
    let formData: any;
    if (mode === "primary") {
      formData = this.props.formData;
    } else {
      formData = this.props.secondarySubjects;
    }

    let subjectData: any = [];
    let subSubjectData: any = [];
    let chapterData: any = [];
    let conceptData: any = [];
    try {
      formData.forEach((subject: any) => {
        const { checked: subjectCheck, subSubjects, subjectId } = subject;
        if (!subjectId) {
          return "";
        }
        if (subjectId.checked || subjectCheck) {
          subjectData.push(["forClass", subjectId]);
          return;
        }
        subSubjects.forEach((subSubject: any) => {
          const {
            checked: subSubjectCheck,
            chapters,
            subSubjectId,
          } = subSubject;
          if (!subSubjectId) {
            return "";
          }
          if (!subjectId.checked && (subSubjectId.checked || subSubjectCheck)) {
            subSubjectData.push(["forClass", subjectId, subSubjectId]);
            return;
          }
          chapters.forEach((chapter: any) => {
            const { checked: chapterCheck, concepts, chapterId } = chapter;
            if (!chapterId) {
              return "";
            }

            if (!subSubjectId.checked && (chapterId.checked || chapterCheck)) {
              chapterData.push([
                "forClass",
                subjectId,
                subSubjectId,
                chapterId,
              ]);
              return;
            }

            concepts.forEach((concept: any) => {
              const {
                checked: conceptCheck,
                classId,
                conceptId,
                conceptCode,
              } = concept;
              if (!conceptId) {
                return "";
              }
              if (conceptCode) conceptId.conceptCode = conceptCode;
              conceptId.checked = true;

              if (!chapterId.checked && (conceptId.checked || conceptCheck)) {
                conceptData.push([
                  classId,
                  subjectId,
                  subSubjectId,
                  chapterId,
                  conceptId,
                ]);
              }
              if (subjectId.checked || subjectCheck) {
                subjectData[0][0] = classId;
              }
              if (subSubjectId.checked || subSubjectCheck) {
                subSubjectData[0][0] = classId;
              }
              if (chapterId.checked || chapterCheck) {
                chapterData[0][0] = classId;
              }
              if (conceptId.checked || conceptCheck) {
                conceptData[0][0] = classId;
              }
            });
          });
        });
      });
      return { subjectData, subSubjectData, chapterData, conceptData };
    } catch (e) {
      let subjectData: any = [];
      let subSubjectData: any = [];
      let chapterData: any = [];
      let conceptData: any = [];
      return { subjectData, subSubjectData, chapterData, conceptData };
    }
  };

  handleModeChange = (evt: any) => {
    const newMode = evt.target.value;
    this.setState({ currentlyActiveMode: newMode });
    this.handleBreadcrumbClick(newMode, "", -1);
  };

  isAlreadySelectedInOtherSubjectType = (item: any) => {
    if (!this.props.allowSecondarySubjects || !item) {
      return false;
    }
    const { currentlyActiveMode } = this.state;
    let otherActiveIds: Set<string>;
    if (currentlyActiveMode === "primary") {
      otherActiveIds = this.state.secondary.currentlyActiveIds;
    } else {
      otherActiveIds = this.state.primary.currentlyActiveIds;
    }
    const itemId = item._id;

    return otherActiveIds.has(itemId);
  };

  toggleCurrentlyActiveItemId = (
    mode: ActiveMode,
    itemId: string,
    action: "add" | "remove" | "toggle" = "toggle"
  ) => {
    // remove item's id from currentlyActiveIds array
    this.setState((prevState) => {
      const newCurrentlyActiveIds = new Set(prevState[mode].currentlyActiveIds);
      if (action === "add") {
        newCurrentlyActiveIds.add(itemId);
      } else if (action === "remove") {
        newCurrentlyActiveIds.delete(itemId);
      } else if (action === "toggle") {
        if (newCurrentlyActiveIds.has(itemId)) {
          newCurrentlyActiveIds.delete(itemId);
        } else {
          newCurrentlyActiveIds.add(itemId);
        }
      }

      return {
        ...prevState,
        [mode]: {
          ...prevState[mode],
          currentlyActiveIds: newCurrentlyActiveIds,
        },
        isDataLoaded: true,
      };
    });
  };
  extractCharacters = (str: string) => {
    let _str = ''
    str.split(' ').map(s => {
      _str += s[0].toUpperCase()
    })
    return _str
  }
  getOpenedEntityIdByLevel = (level: ENTITIES) => {
    const { currentlyActiveMode } = this.state;
    const { openedEntities } = this.state[currentlyActiveMode];
    let openedEntityId;
    if (level === ENTITIES.CLASSES) {
      openedEntityId = openedEntities.classId
    } else if (level === ENTITIES.SUBJECTS) {
      openedEntityId = openedEntities.subjectId
    } else if (level === ENTITIES.SUB_SUBJECTS) {
      openedEntityId = openedEntities.subSubjectId
    } else if (level === ENTITIES.CHAPTERS) {
      openedEntityId = openedEntities.chapterId
    } else if (level === ENTITIES.CONCEPTS) {
      openedEntityId = openedEntities.conceptId
    }
    return openedEntityId
  }
  getNextLevelEntity = (currentLevel: ENTITIES) => {
    if (currentLevel === ENTITIES.CLASSES) {
      return ENTITIES.SUBJECTS
    } else if (currentLevel === ENTITIES.SUBJECTS) {
      return ENTITIES.SUB_SUBJECTS
    } else if (currentLevel === ENTITIES.SUB_SUBJECTS) {
      return ENTITIES.CHAPTERS
    } else if (currentLevel === ENTITIES.CHAPTERS) {
      return ENTITIES.CONCEPTS
    }
    return null;
  }
  renderEntityIcon = (level: ENTITIES, name: string) => {
    const { classes } = this.props;
    let url = '';
    let alt = "goal-icon";
    let subjectName = '';
    if (level === ENTITIES.SUBJECTS) {
      subjectName = name.split(' ').join('').toLowerCase()
    }
    switch (level) {
      case ENTITIES.CLASSES: {
        url = "/assets/svg/myLibrary/goalLevel/goal-icon.svg"
        alt = "goal-icon";
        break;
      }
      case ENTITIES.SUBJECTS: {
        if (iconsForSubjects[subjectName]) {
          url = `/assets/svg/myLibrary/${subjectName}.svg`;
          alt = "subject-icon";
        } else {
          return <Avatar className={classes.purple}>{this.extractCharacters(subjectName)}</Avatar>
        }
        break;
      }
      case ENTITIES.SUB_SUBJECTS: {
        url = "/assets/svg/myLibrary/goalLevel/subject-type-icon.svg";
        alt = "sub-subject-icon"
        break;
      }
      case ENTITIES.CHAPTERS: {
        url = "/assets/svg/myLibrary/goalLevel/subject-type-icon.svg";
        alt = "chapters-icon"
        break;
      }

      case ENTITIES.CONCEPTS: {
        url = "/assets/svg/myLibrary/goalLevel/subject-type-icon.svg";
        alt = "concept-icon"
        break;
      }

    }
    return (
      <img
        src={url}
        alt={alt}
      />
    );
  }

  isConceptAlreadyAdded = (item: any) => {
    const { currentlyActiveMode } = this.state;
    const { currentlyActiveIds } = this.state[currentlyActiveMode];
    const { name, _id } = item;
    const alreadySelectedInOtherSubjectType = this.isAlreadySelectedInOtherSubjectType(
      item
    );
    const isCheckedInCurrentSubjectType = currentlyActiveIds.has(_id);
    const isChecked = isCheckedInCurrentSubjectType || alreadySelectedInOtherSubjectType;
    return isChecked;
  }

  autoPopulateConcepts = (extractConcepts: any = true) => {
    const {data = []} = this.props;
    let isChecked = this.state.isConceptAutoPopulateChecked;
    if(!extractConcepts) {
      updateQueryParams('autoFillConcepts', extractConcepts);
      this.setState((prevState: any, ) => ({
        ...prevState,
        isConceptAutoPopulateChecked: extractConcepts,
      }));
      return;
    }
    if(data && data.length && isChecked) {
      for (const singleDataObj of data) {
        const {questions = []} = singleDataObj;
        const contentIds = questions.map((question : any) => {
          const {content_Id = ''} = question;
          return content_Id;
        });
        const filter = {
          contentIds,
        };
        contentService.contentList(filter, 1, contentIds.length).then(
          (res: any) => { 
            const {contents = []} = res;
            this.populateQuestionSyllabus({
              item: [
                {
                  questions: [...contents],
                }
              ]
            });
          },
          err => { }
        );
      }
    }
  }

  handleAutoPopulateConceptToggle = (event: any) => {
    const isChecked = event.target.checked;
    updateQueryParams('autoFillConcepts', isChecked);
    
    if(Object.keys(event).length) {
      event.stopPropagation();
    }
    this.setState((prevState: any, ) => ({
      ...prevState,
      isConceptAutoPopulateChecked: isChecked,
    }), () => {
      if(isChecked) {
        this.autoPopulateConcepts();
      }
    });
  }

  populateQuestionSyllabus = (props: any) => {
    if(!this.state.isConceptAutoPopulateChecked) {
      return;
    }
    const { item = [] } = props;
    const level : string = props.level || 'concepts';
    if(!item.length) {
      return;
    }
    const finalConceptPayload : any = [];
    item.forEach((individualSection: any) => {
      const {questions = []} = individualSection;
      if(!questions || !questions.length) {
        return;
      }
      questions.forEach((question : any) => {
        const conceptPayload : any = {};
        conceptPayload.aclMetaData = {};
        const {aclMetaData = {}, contentDetails = []} = question;
        const {clientId = '', createdBy = {}, updatedBy = {}} = aclMetaData;
        conceptPayload.aclMetaData.clientId = clientId;
        const {id : createdByObj = {}, email: createdByEmail = ''} = createdBy;
        const {id : updatedByObj = {}, email: updatedByEmail = ''} = updatedBy;
        if(createdByObj && Object.keys(createdByObj)) {
          const {_id : createdById = ''} = createdByObj;
          conceptPayload.aclMetaData.createdBy = {
            id: createdById || '',
            email: createdByEmail,
          };
        }
        if(updatedByObj && Object.keys(updatedByObj)) {
          const {_id : updatedById = ''} = updatedByObj;
          conceptPayload.aclMetaData.updatedBy = {
            id: updatedById || '',
            email: updatedByEmail,
          };
        }
  
        const {subjects = []} = contentDetails;
        subjects.forEach((subject : any) => {
          const {id : subjectId = '', name: subjectName = ''} = subject;
          conceptPayload.subject = {
            id: subjectId,
            name: subjectName,
          };
          const {subSubjects = []} = subject;
          subSubjects.forEach((subSubject: any) => {
            const {subSubjectId: subSubjectObj = {}} = subSubject;
            const {_id : subSubjectId = '', name: subSubjectName = ''} = subSubjectObj;
            conceptPayload.subsubject = {
              id: subSubjectId,
              name: subSubjectName,
            };
            const {chapters = []} = subSubject;
            chapters.forEach((chapter: any) => {
              const {chapterId : chapterObj = {}, concepts = []} = chapter;
              const {_id: chapterId = '', name: chapterName = ''} = chapterObj;
              conceptPayload.chapter = {
                id: chapterId,
                name: chapterName
              };
              concepts.forEach((concept: any) => {
                const {conceptId : conceptObj = {}, conceptCode = '', classId: classObj = {}} = concept;
                const {_id: conceptId = '', name: conceptName = ''} = conceptObj;
                const {_id: classId = '', name: className = ''} = classObj;
                conceptPayload.name =  conceptName;
                conceptPayload.conceptCode = conceptCode;
                conceptPayload._id = conceptId;
                conceptPayload.class = {
                  id: classId,
                  name: className,
                }
                conceptPayload.checked = false;
                finalConceptPayload.push({...conceptPayload});
              });
            });
          });
        });
      });
    })

    finalConceptPayload.forEach((conceptPayload: any) => {
      const newConceptPayload = [conceptPayload];
      const { currentlyActiveMode } = this.state;
      const { currentlyActiveIds } = this.state[currentlyActiveMode];
      if(this.isConceptAlreadyAdded(conceptPayload)) {
        return;
      }
      this.setState((prevState) => ({
        ...prevState,
        [currentlyActiveMode]: {
          ...prevState[currentlyActiveMode],
          classId: {
            _id: conceptPayload.class.id,
            name: conceptPayload.class.name,
          },
          subjectId: {
            _id: conceptPayload.subject.id || '',
            name: conceptPayload.subject.name || ''
          },
          chapterId: {
            _id: conceptPayload.chapter.id || '',
            name: conceptPayload.chapter.name || ''
          },
          chapters: conceptPayload,
          subSubjects: conceptPayload,
          [level]: [conceptPayload],
        },
      }), () => {
        const { name, _id } = conceptPayload;
        const alreadySelectedInOtherSubjectType = this.isAlreadySelectedInOtherSubjectType(
          conceptPayload
        );
        const isCheckedInCurrentSubjectType = currentlyActiveIds.has(_id);
        this.onEntityCheckboxClick({}, {
          item: conceptPayload,
          alreadySelectedInOtherSubjectType, 
          isCheckedInCurrentSubjectType,
          index: 0,
          level,
        });
      });
    })
  }

  onEntityCheckboxClick = (e: any, props: any) => {
    const { item, alreadySelectedInOtherSubjectType, isCheckedInCurrentSubjectType, index, level } = props;
    if(e && Object.keys(e).length) {
      e.stopPropagation();
    }
    if (alreadySelectedInOtherSubjectType) {
      return;
    }

    const { currentlyActiveMode } = this.state;
    const { currentlyActiveIds } = this.state[currentlyActiveMode];
    let formData: any;
    if (currentlyActiveMode === "primary") {
      formData = this.props.formData;
    } else {
      formData = this.props.secondarySubjects;
    }

    // check in case of edit case
    if (currentlyActiveIds.has(item._id)) {
      this.removeConceptMapping(currentlyActiveMode, level, item);
      return "";
    } else {
      this.toggleCurrentlyActiveItemId(currentlyActiveMode, item._id, 'add');
    }
    const activeItemData = _.get(
      this.state[currentlyActiveMode],
      level,
      []
    );
    if (activeItemData[index].checked !== isCheckedInCurrentSubjectType) {
      activeItemData[index].checked = isCheckedInCurrentSubjectType;
    }
    if (!activeItemData[index].checked) {
      activeItemData[index].checked = true;
    } else {
      activeItemData[index].checked = !activeItemData[index].checked;
    }
    this.setState((prevState) => ({
      ...prevState,
      [currentlyActiveMode]: {
        ...prevState[currentlyActiveMode],
        [level]: activeItemData,
      },
    }));
    if (activeItemData[index].checked) {
      const type = this.skipLastCharAndLowerCase(level)
      this.toggleCurrentlyActiveItemId(
        currentlyActiveMode,
        item._id,
        "add"
      );
      if (level === "concepts") {
        this.addConceptMappingInForm(currentlyActiveMode, item, formData, {
          type,
          id: item._id,
        });
        if (currentlyActiveMode === "primary") {
          this.props.handleFormChange(formData);
        } else {
          this.props.handleSecondarySubjectChange(formData);
        }
      } else {
        this.getMasterConcept({
          type: type,
          id: item._id,
          mode: currentlyActiveMode,
        });
      }
    } else {
      this.removeConceptMapping(currentlyActiveMode, level, item);
    }
    setTimeout(() => {
      this.updateConceptFormData(currentlyActiveMode);
    }, 100);
  };
  renderEntities = (level: ENTITIES, setSectionFocus: SectionFocusedContextValue["setSectionFocus"], spacing = 0) => {
    const { classes } = this.props;
    const { currentlyActiveMode } = this.state;
    const { currentlyActiveIds } = this.state[currentlyActiveMode];
    const data = this.state[currentlyActiveMode][level];
    const openedEntityId = this.getOpenedEntityIdByLevel(level);
    const isConceptLevel = level === ENTITIES.CONCEPTS;

    return (data || []).map((item, index) => {
      const { name, _id } = item;
      const alreadySelectedInOtherSubjectType = this.isAlreadySelectedInOtherSubjectType(
        item
      );
      const isCheckedInCurrentSubjectType = currentlyActiveIds.has(_id)
      const isChecked = isCheckedInCurrentSubjectType || alreadySelectedInOtherSubjectType;
      const studentUser = getUserType(USER_TYPE.STUDENT);
      const isOpened = openedEntityId === _id || ( studentUser && ENTITIES.CLASSES === level);
      const nextLevel: any = this.getNextLevelEntity(level);
      return (
        <Grid
          className={classes.conceptSpacing}
          style={{ marginLeft: spacing }}
          item
          xs={12}
          key={_id}
        >
          <Grid
            container
            className={classes.entityContainer}
            alignItems="center"
            onClick={() =>
              !studentUser && this.handleOpenEntity(currentlyActiveMode, level, item)
            }
          >
            {!studentUser && <Grid item xs="auto">
              {(!isConceptLevel && isOpened) ? <KeyboardArrowDownIcon /> : !isConceptLevel && <KeyboardArrowRightIcon />}
            </Grid>}
            <Grid item xs className={classes.conceptIcon}>
              {this.renderEntityIcon(level, name)}
              {level === ENTITIES.CLASSES ? 'Class ' : ''} {name}
            </Grid>
            {(isChecked || this.checkBoxVisible(level)) && (
              <Grid item xs="auto">
                <Checkbox
                  className={classes.checkbox}
                  value={item._id}
                  disabled={alreadySelectedInOtherSubjectType}
                  onFocus={() => setSectionFocus(true)}
                  onBlur={() => setSectionFocus(false)}
                  onClick={(e: any) => {
                    const newPrimary = { ...this.state.primary };
                    if(studentUser){
                      newPrimary.currentlyActiveIds = new Set();
                      this.props.handleFormChange([]);
                    }
                    this.setState({ primary: { ...newPrimary } },()=>{
                      this.onEntityCheckboxClick(e, { level, item, alreadySelectedInOtherSubjectType, isCheckedInCurrentSubjectType, index })
                    })
                  }}
                  checked={isChecked}
                  color="primary"
                />
              </Grid>
            )}

            {/* <span className={classes.conceptIcon}>
              {(!isConceptLevel && isOpened) ? <KeyboardArrowDownIcon /> : !isConceptLevel && <KeyboardArrowRightIcon />}
              {this.renderEntityIcon(level, name)}
              {level === ENTITIES.CLASSES ? 'Class ' : ''} {name}
            </span> */}
          </Grid>
          {((isOpened && nextLevel)) && (
            <div className={isChecked ? classes.disabledEntity : ''}>{this.renderEntities(nextLevel, setSectionFocus, spacing + 10)}</div>
          )}
        </Grid>
      );
    })
  }

  checkBoxVisible(level: string) {
    const allowedEntry = level !== ENTITIES.CLASSES;
    const content = _.get(ChaptersAndConceptsForContent, this.props.contentType || '', []);
    const allowedContent = !content.length || content.includes(level);
    const showSubjectCheckbox = level === ENTITIES.SUBJECTS && getUserType(USER_TYPE.STUDENT);
    return (allowedContent && allowedEntry) || showSubjectCheckbox;
  }

  handleGoalSelection = (selectedGoalList: any[]) => {
    selectedGoalList = selectedGoalList || []
    const selectedExams = (selectedGoalList || []).map((selection) => ({
      name: selection.label,
      id: selection.value,
    }));
    this.props.handleCourseChange && this.props.handleCourseChange(selectedExams);
    this.props.setSyllabusExams({ qId: this.props.questionId, selectedExams });
    this.props.updateRelevantExam && !this.props.questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE) && this.props.setActiveGoals(selectedExams);
    this.props.handleUpdateRelevantExam && this.props.handleUpdateRelevantExam(selectedExams);
    this.setState({ selectedGoalList: selectedExams },
      () => {
        this.fetchGoalWiseClasses(getUserType(USER_TYPE.STUDENT));
      }
    );
    // Goal update for all type of question 
    // if (!this.props.questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE)) {
      this.props.setSelectedGoals({ [this.props.questionId || '']: selectedExams });
    // }
    this.props.setBenchmarkingUpdate(true);
  }

  transformGoals(goalListing: any[]) {
    if (!goalListing) {
      return;
    }
    const newGoalListing: any[] = [];
    goalListing.map((goal) => {
      if (goal && goal.courseType) {
        newGoalListing.push({
          label: goal.courseType.name,
          value: goal.courseType.id,
          id: goal.courseType.id
        });
      }
    });
    this.setState({ goalListing: newGoalListing }, () => {
      relevantExamsService.getStudentDetails().then(res=>{
        this.setState({ studentDetails: res && res.studentDetails });
        getUserType(USER_TYPE.STUDENT) && this.handleGoalSelection(newGoalListing);
      })

    });
  }

  getTransformedValues = (relevantExams: any) => {
    return relevantExams.map((exam: any) => ({
      label: exam.name,
      id: exam.id,
      value: exam.id,
    }));
  };

  getGaolListingEmptyScreen() {
    const { classes } = this.props
    return (<div className={classes.emptyContainer}>
      <img src='/assets/svg/goalEmptyScreen.png' alt='Empty Screen' />
      <div>Please select a goal to proceed with Chapter(s) or Concept(s) tagging</div>
    </div>);
  }

  showEmptyScreenForSearchListing() {
    const { classes } = this.props;
    return (<div className={classes.snapScreen}>
      <img src="/assets/svg/snap-empty.svg" alt="Empty" />
      <h6>Oh Snap! We can’t find it</h6>
      <p>Please Search the relevant Chapter or Concept</p>
    </div>);
  }

  render() {
    const {
      classes,
      isRequired,
      customHeading,
      defaultExpanded = true,
      panelProps,
      formData,
      error,
      errorText,
      allowSecondarySubjects,
      secondarySubjects,
      showWithoutExpansionPanel = false,
      questionIndex,
      goalMandatory,
      match
    } = this.props;

    const { isConceptAutoPopulateChecked, currentlyActiveMode, primary: { currentlyActiveIds: primaryActiveIds }, secondary: { currentlyActiveIds: secondaryActiveIds }, searchStr } = this.state;

    const {
      showSuggestedConcept,
      suggestedConcept,
    } = this.state[currentlyActiveMode];

    const totalConceptsAdded = primaryActiveIds.size + secondaryActiveIds.size;
    const { goalListing, selectedGoalList } = this.state;
    const studentUser = getUserType(USER_TYPE.STUDENT);

    const createSucjectChip = (mode: ActiveMode, subjectData: any) => {
      if (!subjectData || subjectData.length === 0) {
        return null;
      }
      return subjectData.map((subject: any, index: number) => (
        <span
          className={classes.chipItem}
          key={`${subject[1]._id} ${index}`}
        >
          <Chip
            className={classes.filterChip}
            label={subject[1].name}
            onDelete={() => {
              this.removeConceptMapping(mode, "subjects", subject[1]);
            }}
          />
        </span>
      ));
      // return subjectData.map((subject: any, index: number) => (
      //   <div className={classes.mb2x} key={`${subject[1]._id} ${index}`}>
      //     {/* <ul className={classes.selectedBreadCrumb}>
      //       <li>Class {_.get(subject, "0.name", "")}</li>
      //     </ul> */}
      //     <ul className={classes.selectedBreadCrumb}>
      //       <li className={classes.chipItem}>
      //         <Chip
      //           className={classes.filterChip}
      //           label={subject[1].name}
      //           onDelete={() => {
      //             this.removeConceptMapping(mode, "subjects", subject[1]);
      //           }}
      //         />
      //       </li>
      //     </ul>
      //   </div>
      // ));
    };

    const createSubSucjectChip = (mode: ActiveMode, subSubjectData: any) => {
      if (!subSubjectData || subSubjectData.length === 0) {
        return null;
      }
      return subSubjectData.map((subSubject: any, index: number) => (
        <span
          className={classes.chipItem}
          key={`${subSubject[1]._id} ${index}`}
        >
          <Chip
            label={subSubject[2].name}
            className={classes.filterChip}
            onDelete={() => {
              this.removeConceptMapping(
                mode,
                "subsubjects",
                subSubject[2]
              );
            }}
          />
        </span>
      ));
      // return subSubjectData.map((subSubject: any, index: number) => (
      //   <div className={classes.mb2x} key={`${subSubject[1]._id} ${index}`}>
      //     {/* <ul className={classes.selectedBreadCrumb}>
      //       <li>Class {subSubject[0].name}</li>
      //       <li>{subSubject[1].name}</li>
      //     </ul> */}
      //     <ul className={classes.selectedBreadCrumb}>
      //       <li className={classes.chipItem}>
      //         <Chip
      //           label={subSubject[2].name}
      //           className={classes.filterChip}
      //           onDelete={() => {
      //             this.removeConceptMapping(mode, "subsubjects", subSubject[2]);
      //           }}
      //         />
      //       </li>
      //     </ul>
      //   </div>
      // ));
    };

    const createChapterChip = (mode: ActiveMode, chapterData: any) => {
      if (!chapterData || chapterData.length === 0) {
        return null;
      }
      return chapterData.map((chapter: any, index: number) => (
        <span
          className={classes.chipItem}
          key={`${chapter[1]._id} ${index}`}
        >
          <Chip
            label={chapter[3].name}
            className={classes.filterChip}
            onDelete={() => {
              this.removeConceptMapping(mode, "chapters", chapter[3]);
            }}
          />
        </span>
      ));
      // return chapterData.map((chapter: any, index: number) => (
      //   <div className={classes.mb2x} key={`${chapter[1]._id} ${index}`}>
      //     {/* <ul className={classes.selectedBreadCrumb}>
      //       <li>Class {_.get(chapterData, "0.name", "")}</li>
      //       <li>{_.get(chapter, "1.name", "")}</li>
      //       <li>{_.get(chapter, "2.name", "")}</li>
      //     </ul> */}
      //     <ul className={classes.selectedBreadCrumb}>
      //       <li className={classes.chipItem}>
      //         <Chip
      //           label={chapter[3].name}
      //           className={classes.filterChip}
      //           onDelete={() => {
      //             this.removeConceptMapping(mode, "chapters", chapter[3]);
      //           }}
      //         />
      //       </li>
      //     </ul>
      //   </div>
      // ));
    };

    const createConceptChip = (mode: ActiveMode, conceptData: any) => {
      if (!conceptData || conceptData.length === 0) {
        return null;
      }
      return conceptData.map((concept: any, index: number) => (
        <span
          className={classes.chipItem}
          key={`${concept[1]._id} ${index}`}
        >
          <Chip
            label={concept[4].name}
            className={classes.filterChip}
            onDelete={() => {
              this.removeConceptMapping(mode, "concepts", concept[4], true);
            }}
          />
        </span>
      ));
      // return conceptData.map((concept: any, index: number) => (
      //   <div className={classes.mb2x} key={`${concept[1]._id} ${index}`}>
      //     {/* <ul className={classes.selectedBreadCrumb}>
      //       <li>Class {_.get(concept, "0.name", "")}</li>
      //       <li>{_.get(concept, "1.name", "")}</li>
      //       <li>{_.get(concept, "2.name", "")}</li>
      //       <li>{_.get(concept, "3.name", "")}</li>
      //     </ul> */}
      //     <ul className={classes.selectedBreadCrumb}>
      //       <li className={classes.chipItem}>
      //         <Chip
      //           label={concept[4].name}
      //           className={classes.filterChip}
      //           onDelete={() => {
      //             this.removeConceptMapping(mode, "concepts", concept[4]);
      //           }}
      //         />
      //       </li>
      //     </ul>
      //   </div>
      // ));
    };

    const generateFormDataBreadCrumb = (e: any, mode: ActiveMode) => {
      const {
        subjectData,
        subSubjectData,
        chapterData,
        conceptData,
      } = this.getNewConceptMapping(mode);
      return [
        createSucjectChip(mode, subjectData),
        createSubSucjectChip(mode, subSubjectData),
        createChapterChip(mode, chapterData),
        createConceptChip(mode, conceptData),
      ];
    };

    const renderExpansionBody = () => {
      return (
        <SectionFocusedContext.Consumer>
          {({ setSectionFocus }: SectionFocusedContextValue) => (
            <div className={this.props.customDisabled ? classes.customDisable : ''}>
              <Grid container spacing={16}>
                {allowSecondarySubjects && (
                  <Grid item xs={6}>
                    {/* <Grid item> */}
                    {/* <FormControl className={classes.formControl}> */}
                    {/* <RadioGroup
                          aria-label="Concept mode"
                          name="conceptMode"
                          className={classes.group}
                          // onChange={this.handleChange}
                          onChange={this.handleModeChange}
                        >
                          <FormControlLabel
                            value="primary"
                            control={
                              <Radio
                                color="primary"
                                disableRipple={true}
                                checked={currentlyActiveMode === "primary"}
                              />
                            }
                            label="Primary*"
                            classes={{ label: classes.customLabel }}
                          />
                          <Grid>
                            <CustomInfoIcon
                              infoDialogContentType="Add alternate answer"
                              isInfoIcon={true}
                              isRightArrow={false}
                              isCenterArrow={true}
                              toolTipDirection="top"
                              knowMoreAbout={false}
                              showTooltip={false}
                              details="Click to know more"
                              dialogTitle="Primary Concept"
                              imageURL="/assets/svg/myLibrary/primary-concept-icon.svg"
                              dialogPara={
                                <Typography>
                                  <span className={classes.dialogSubheading}>
                                    This is a mandatory field. Primary concept is
                                    the main root concept for the content. This
                                    will be considered in student analytics. You
                                    can add one more more primary concepts
                                  </span>
                                </Typography>
                              }
                            />
                          </Grid>

                          <FormControlLabel
                            value="secondary"
                            control={
                              <Radio
                                color="primary"
                                disableRipple={true}
                                checked={currentlyActiveMode === "secondary"}
                              />
                            }
                            label="Secondary"
                            classes={{ root: classes.customLabel }}
                          />
                          <Grid>
                            <CustomInfoIcon
                              infoDialogContentType="Add alternate answer"
                              isInfoIcon={true}
                              isRightArrow={false}
                              isCenterArrow={true}
                              toolTipDirection="top"
                              knowMoreAbout={false}
                              showTooltip={false}
                              dialogTitle="Secondary Concept"
                              details="Click to know more"
                              imageURL="/assets/svg/myLibrary/secondary-concept-icon.svg"
                              dialogPara={
                                <Typography>
                                  <span className={classes.dialogSubheading}>
                                    This is an optional field. Secondary concept
                                    refers to the other concepts that are related
                                    to the same content. It is advisable to add
                                    this tag as it will help you in filtering
                                    content based on one or more concepts which
                                    may or may not be primary. This will not be
                                    considered in student analytics. You can add
                                    one or more secondary concepts.
                                  </span>
                                </Typography>
                              }
                            />
                          </Grid>
                        </RadioGroup> */}
                    {/* </FormControl> */}
                    {/* </Grid> */}
                    {/* </Grid> */}
                  </Grid>
                )}
              </Grid>
              {
                (match.params && match.params.type == 'testpapers') && 
                <Grid item xs className={classes.conceptIcon}>
                  Automatically retrieve the syllabus based on the concepts tagged to the questions
                  <Switch
                    checked={isConceptAutoPopulateChecked}
                    onChange={(e : any) => this.handleAutoPopulateConceptToggle(e)}
                    value="publishDirect"
                    color="primary"
                    classes={{
                      switchBase: classes.iOSSwitchBase,
                      bar: classes.iOSBar,
                      icon: classes.iOSIcon,
                      iconChecked: classes.iOSIconChecked,
                      checked: classes.iOSChecked,
                    }}
                  />
                </Grid>
              }
              <Grid container spacing={16}>
                <Grid
                  item
                  xs={6}
                  className={[
                    classes.searchConceptBox,
                    // classes.borderBox,
                  ].join(" ")}
                >
                  <Grid className={classes.borderBox}>
                    <Grid container>
                      <Grid item xs>
                        <Typography variant="h6">{totalConceptsAdded} {studentUser?<>Subject</>:<>Concept</>}{totalConceptsAdded === 1 ? '' : 's'} added</Typography>
                      </Grid>
                      <Grid item xs="auto">
                        <Button variant="text" color="primary" onClick={this.resetAllConceptMappings} disabled={totalConceptsAdded === 0}>Reset</Button>
                      </Grid>
                    </Grid>
                    <Grid>
                      {allowSecondarySubjects && (
                        <>
                          <Typography gutterBottom className={classes.conceptHeading}>{studentUser ? <>Subject</> : <>Primary Concept(s)</>}<span className={classes.redColor}>*</span></Typography>
                          <Divider
                            classes={{ root: classes.customDivider }}
                          />
                        </>
                      )}

                      {!_.isEmpty(formData) ? (
                        generateFormDataBreadCrumb(event, "primary")
                      ) : (
                        <Typography className={classes.mutedText}>
                          {allowSecondarySubjects && `No ${studentUser ? 'Subject' : 'Primary concepts'} added, `}
                          {studentUser ? <>Select</> : <>Search or navigate</>}  from the Right panel and Add them
                        </Typography>
                      )}  
                      {/* <Chip
              label="Alternating Current"
              onDelete={this.deletePrimaryConcept}
              className={classes.filterChip}
            /> */}
                      {allowSecondarySubjects && !studentUser && (
                        <>
                          <Typography gutterBottom className={classes.conceptHeading}>Secondary Concept(s)</Typography>
                          <Divider
                            classes={{ root: classes.customDivider }}
                          />

                          {!_.isEmpty(secondarySubjects) ? (
                            generateFormDataBreadCrumb(event, "secondary")
                          ) : (
                            <Typography className={classes.mutedText}>No Secondary concepts added, Search or navigate from the Right panel and Add them </Typography>
                          )}
                        </>
                      )}
                    </Grid>

                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={6}
                  className={[
                    classes.exploreConceptBox,
                    // classes.borderBox,
                  ].join(" ")}
                >
                  {/* <Typography variant="body1" gutterBottom>
                  Explore Concept
                </Typography> */}
                  {/* <div className={classes.mb2x}>
                  {generateBreadCrumb()}
                  <Typography variant="caption" inline>
                    ({buttonsList.length})
                  </Typography>
                </div> */}
                  <Grid className={classes.borderBox}>
                    {allowSecondarySubjects && !studentUser && <RadioGroup
                      aria-label="Concept mode"
                      name="conceptMode"
                      className={classes.group}
                      // onChange={this.handleChange}
                      onChange={this.handleModeChange}
                    >
                      <FormControlLabel
                        value="primary"
                        control={
                          <Radio
                            color="primary"
                            disableRipple={true}
                            checked={currentlyActiveMode === "primary"}
                            onFocus={() => setSectionFocus(true)}
                            onBlur={() => setSectionFocus(false)}
                          />
                        }
                        label="Primary*"
                        classes={{ label: classes.customLabel }}
                      />
                      <Grid>
                        <CustomInfoIcon
                          infoDialogContentType="Add alternate answer"
                          isInfoIcon={true}
                          isRightArrow={false}
                          isCenterArrow={true}
                          toolTipDirection="top"
                          knowMoreAbout={false}
                          showTooltip={false}
                          details="Click to know more"
                          dialogTitle="Primary Concept"
                          imageURL="/assets/svg/myLibrary/primary-concept-icon.svg"
                          dialogPara=""
                          htmlElement={
                            <Typography>
                              <span className={classes.dialogSubheading}>
                                This is a mandatory field. Primary concept
                                is the main root concept for the content.
                                This will be considered in student
                                analytics. You can add one more primary
                                concepts
                              </span>
                            </Typography>
                          }
                        />
                      </Grid>

                      <FormControlLabel
                        value="secondary"
                        control={
                          <Radio
                            color="primary"
                            disableRipple={true}
                            checked={currentlyActiveMode === "secondary"}
                            onFocus={() => setSectionFocus(true)}
                            onBlur={() => setSectionFocus(false)}
                          />
                        }
                        label="Secondary"
                        classes={{ root: classes.customLabel }}
                      />
                      <Grid>
                        <CustomInfoIcon
                          infoDialogContentType="Add alternate answer"
                          isInfoIcon={true}
                          isRightArrow={false}
                          isCenterArrow={true}
                          toolTipDirection="top"
                          knowMoreAbout={false}
                          showTooltip={false}
                          dialogTitle="Secondary Concept"
                          details="Click to know more"
                          imageURL="/assets/svg/myLibrary/secondary-concept-icon.svg"
                          dialogPara=""
                          htmlElement={
                            <Typography>
                              <span className={classes.dialogSubheading}>
                                This is an optional field. Secondary concept
                                refers to the other concepts that are
                                related to the same content. It is advisable
                                to add this tag as it will help you in
                                filtering content based on one or more
                                concepts which may or may not be primary.
                                This will not be considered in student
                                analytics. You can add one or more secondary
                                concepts.
                              </span>
                            </Typography>
                          }
                        />
                      </Grid>
                    </RadioGroup>}

                    <div className={classes.suggestContainer}>
                      {!studentUser && <SearchField
                        placeholder="Search Concept &amp; Chapter"
                        className={classes.searchConceptRoot}
                        onFocus={() => {
                          setSectionFocus(true)
                          this.showSuggestedConcept(true);
                        }}
                        onBlur={() => {
                          setSectionFocus(false)
                          this.showSuggestedConcept(false);
                        }}
                        value={this.state.searchStr}
                        onChange={(e: any) => {
                          this.handleSearchOnChange(e.target.value);
                        }}
                        fullWidth
                        endAdornment={
                          <InputAdornment position="end" onClick={() => this.handleSearchOnChange('')} className={classes.clickable}>
                            <CloseIcon />
                          </InputAdornment>
                        }
                      />}
                      {showSuggestedConcept && suggestedConcept.length > 0 && (
                        <ul className={classes.suggestList}>
                          {_.map(suggestedConcept, (sc, i: number) => {
                            const disabledClass = sc.disabled
                              ? classes.disabledSuggestion
                              : "";
                            let disabledTitle = "";
                            if (
                              this.state.primary.currentlyActiveIds.has(
                                sc.conceptId
                              )
                            ) {
                              disabledTitle =
                                "Already added in Primary Concept(s)";
                            } else if (
                              this.state.secondary.currentlyActiveIds.has(
                                sc.conceptId
                              )
                            ) {
                              disabledTitle =
                                "Already added in Secondary Concept(s)";
                            }
                            let suggestionName = sc.conceptName;
                            if (sc.disabled) {
                              suggestionName = (
                                <Tooltip
                                  title={
                                    <>
                                      {disabledTitle}
                                      <span
                                        className={classes.arrow}
                                        ref={this.handleArrowRef}
                                      />
                                    </>
                                  }
                                  classes={{
                                    tooltip: classes.bootstrapTooltip,
                                    popper: classes.bootstrapPopper,
                                    tooltipPlacementBottom:
                                      classes.bootstrapPlacementBottom,
                                  }}
                                  PopperProps={{
                                    popperOptions: {
                                      modifiers: {
                                        arrow: {
                                          enabled: Boolean(
                                            this.state.arrowRef
                                          ),
                                          element: this.state.arrowRef,
                                        },
                                      },
                                    },
                                  }}
                                >
                                  <span>{sc.conceptName}</span>
                                </Tooltip>
                              );
                            }
                            return (
                              <li
                                key={i}
                                className={[
                                  classes.suggestItem,
                                  disabledClass,
                                ].join(" ")}
                                onClick={() => {
                                  !sc.disabled &&
                                    this.choosedConcept(
                                      currentlyActiveMode,
                                      sc
                                    );
                                }}
                              >
                                <div className={classes.mybtnGroup}>
                                  <div>{suggestionName}</div>
                                  <div>
                                    <Button
                                      variant="outlined"
                                      color="default"
                                      className={[
                                        classes.suggestBtn,
                                        disabledClass,
                                      ].join(" ")}
                                    >
                                      {" "}
                                      {sc.subjectName}{" "}
                                    </Button>
                                    <Button
                                      variant="outlined"
                                      color="default"
                                      className={[
                                        classes.suggestBtn,
                                        disabledClass,
                                      ].join(" ")}
                                    >
                                      {" "}
                                      Class {sc.className}{" "}
                                    </Button>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </div>

                    <Grid container spacing={16}>
                      <Grid className={classes.conceptContainer}>
                        {!suggestedConcept.length && searchStr ? this.showEmptyScreenForSearchListing() : this.renderEntities(ENTITIES.CLASSES, setSectionFocus)}
                        {/* {_.map(buttonsList, (item, index: number) =>
                    _.isEmpty(buttonsList) ? (
                      <Grid item xs={12} key={`${item._id} ${index}`}>
                        <Typography variant="caption">
                          No concept found
                        </Typography>
                      </Grid>
                    ) : (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={`${item._id} ${index}`}
                      >
                        {generateButtons(item, index)}
                      </Grid>
                    )
                  )} */}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          )}
        </SectionFocusedContext.Consumer>
      );
    }

    if (!showWithoutExpansionPanel) {
      return (
        <MyPATExpansionPanel onClick={(event: any) => {
          event.stopPropagation();
          this.props.addFeedback && this.props.addFeedback('concept', questionIndex)
        }}
          panelProps={panelProps}
          hasExpandIcon
          sectionId={this.props.sectionId || "mapSyllabus"} // used for scrolling to this section
          defaultExpanded={defaultExpanded}
          variant="white"
          customCollapseTitle={
            !_.isEmpty(customHeading) ? (
              customHeading
            ) : (<>

              <Typography variant="h6" onClick={(event) => {event.stopPropagation();}}>
                <span
                  id={this.checkForFeedback() ? 'feedbackScroll' : ''}
                  className={`${classes.feedbackContainer} ${this.checkForFeedback() ? classes.blueColor : ''}
              ${this.props.openFeedback ? classes.feedbackHighlight : ''}`}
                  > Add {studentUser ? 'Subject' : 'Concepts or Chapters'} <span style={{ color: "red" }}>*</span>

                  {this.checkForFeedback() && (
                    <Grid className="feedbackBlock">
                      <AddFeedback
                        author={this.props.authorType}
                        replyFeedback={this.props.replyFeedback} closeFeedback={this.props.closeFeedback} resolveFeedback={this.props.resolveFeedback} clickedfeedbackData={this.props.clickedfeedbackData} addNewFeedback={this.props.addNewFeedback} />
                    </Grid>)}
                    {
                      this.props.activeValidationFeedbackSection === SECTIONS.SYLLABUS && (
                        <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={this.props.handleAddCommentInFeedback} handleCancel={()=>this.props.createNewValidationFeedback && this.props.createNewValidationFeedback('')} feedbackData={this.props.activeValidationFeedbackData} />
                      )
                    }
                </span>
                  <CustomInfoIcon
                    infoDialogContentType="Goal Management"
                    isInfoIcon={true}
                    isRightArrow={false}
                    isCenterArrow={true}
                    knowMoreAbout={false}
                    dialogTitle={`Add ${studentUser ? 'Subject' : 'Concept or Chapter'}`}
                    imageURL="/assets/svg/infoIcon/conceptsAndChapters.svg"
                    dialogPara={studentUser ?`Select the appropriate Subject for which you are creating this question`:`Add the appropriate Concept or Chapters in this section by following the steps: <br/>
                              1. Select the appropriate Goal for which you are creating this question <br/>
                              2. Tag the appropriate Concept or Chapter for which you are creating the question <br/>
                            <strong>Note:</strong> You can also add Secondary concepts in case the question is for more than 1 concept`}
                    details="Click to know more"
                    toolTipDirection="top" />
              </Typography>
            </>
            )
          }
          error={error}
          errorText={errorText}
          showErrorOnTouch
          isDisable={this.props.isDisable}
        >
          {goalMandatory && !studentUser &&
            <div className={classes.rowBox}>
              <div className={classes.w50}>
                <label className={classes.pR10}>Select goal(s) to view the related Chapter(s) or Concept(s):</label>
              </div>
              <div className={classes.w50}>
                <SearchBarWithChips
                  suggestions={goalListing}
                  onSelection={this.handleGoalSelection}
                  values={this.getTransformedValues(selectedGoalList)}
                  placeholderText='Select Goal(s)'
                  notFound='No Goal found.'
                  classes={{ root: classes.searchBarChips }}
                  source={'addConceptOrChapter'}
                  backspaceRemoves={true}
                />
              </div>
              <div className={classes.w100}>
                {!!!selectedGoalList.length && this.getGaolListingEmptyScreen()}
              </div>
            </div>
          }
          {(!!selectedGoalList.length || !goalMandatory) && renderExpansionBody()}
        </MyPATExpansionPanel>

      );
    }
    return renderExpansionBody();
  }
}
const mapStateToProps = (state: any) => ({
  concepts: state.conceptAddReducer.concepts,
  activeGoals: state.questionCreate.relevantExams,
  updateRelevantExam: state.questionCreate.updateRelevantExam,
  questionSpecialPurposes: state.questionCreate.specialPurposes,
  syllabusExams: state.questionCreate.syllabusExams,
  selectedGoals: state.questionCreate.selectedGoals
})
const mapDispatchToProps = (dispatch: any) => {
  return {
    setConcepts: (data: any) => dispatch({ type: 'CONCEPTS', data }),
    setBenchmarkingUpdate: ((data: any) => dispatch({type: 'UPDATE_BENCHMARKING', data})),
    setActiveGoals: (data: any) => dispatch(questionActions.setRelevantExams(data)),
    setSelectedGoals: (data: any) => dispatch(questionActions.setSelectedGoals(data)),
    setSyllabusExams: (data: any) => dispatch(questionActions.setSyllabusExams(data)),
  }
}

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles)(AddConceptOrChapter)));
